// extracted by mini-css-extract-plugin
export default {"section":"Banner_section__T-Mz+","banner":"Banner_banner__niPoK"};